import type { AdminProfile, UpdateAdminProfilePayload } from '@/domain/profile/entities/admin_profile.entity'
import type { ProfileRepository } from '@/domain/profile/repositories/profile_repository'
import { ProfileRtkDatasource } from '../datasources/profile_rtk_datasource'
import { mapAdminProfileDtoToEntity } from '../mappers/profile.mapper'

export class ProfileRepositoryImpl implements ProfileRepository {
  constructor(private readonly remote: ProfileRtkDatasource = new ProfileRtkDatasource()) {}

  async getMe(): Promise<AdminProfile> {
    const dto = await this.remote.getMe()
    return mapAdminProfileDtoToEntity(dto)
  }

  async updateMe(payload: UpdateAdminProfilePayload): Promise<AdminProfile> {
    const dto = await this.remote.updateMe(payload)
    return mapAdminProfileDtoToEntity(dto)
  }
}

export const profileRepository = new ProfileRepositoryImpl()
